<template>
  <div class="product-page">
    <div class="left-text">
      <div
        class="left-text__back"
        :style="{
          height: textBackgroundHeight + 'px',
        }"
      >
        <div
          class="left-text__parallax"
          :style="{
            height: 100 * offsets.length + 'vh',
            transform: parallaxTransform2,
          }"
        ></div>
      </div>
      <div class="left-text__text"></div>
    </div>
    <div
      class="parallax-bg"
      :style="{
        height: 100 * offsets.length + '%',
        transform: parallaxTransform,
      }"
    ></div>
    <div class="sections-next" @click="scrollToSection(activeSection + 1)" v-if="activeSection != offsets.length - 1" :style="{
        marginBottom: textHeight + 'px',
      }">
      <svg xmlns="http://www.w3.org/2000/svg" width="11" height="8" viewBox="0 0 11 8" fill="none">
        <path d="M0.788574 0.884466L5.50011 5.86523L10.2117 0.884466" stroke="#20438C" stroke-width="2"/>
      </svg>
    </div>
    <div class="sections-prev" @click="scrollToSection(activeSection - 1)" v-if="activeSection != 0">
      <svg xmlns="http://www.w3.org/2000/svg" width="11" height="8" viewBox="0 0 11 8" fill="none">
        <path d="M10.2114 6.78839L5.49989 1.80762L0.788349 6.78839" stroke="#20438C" stroke-width="2"/>
      </svg>
    </div>
    <div
      class="sections-menu"
      :style="{
        marginTop: -(textHeight - headerHeight) / 2 + 'px',
      }"
    >
      <span
        class="menu-point"
        v-bind:class="{ active: activeSection == index }"
        v-on:click="scrollToSection(index)"
        v-for="(offset, index) in offsets"
        v-bind:key="index"
      >
      </span>
    </div>
    <div ref="packOverlay" class="cigarettes-pack-page cigarettes-pack-page-5" :class="{'mobile-rotate': mobileRotate}">
      <canvas class="canvas-3d" :class="{'canvas-3d_hidden': !allAssetsLoaded}" ref="canvas3D"></canvas>
      <div
        v-if="assetLoadFailed"
        class="cigarettes-pack-page__placeholder cigarettes-pack-page__placeholder_5"
        :class="{'cigarettes-pack-page__placeholder_hidden': !placeholderVisible}"
      ></div>
      <div class="canvas-3d__loader" :class="{'canvas-3d__loader_hidden': !modelPreloaderVisible}">
        <img src="/frontend/assets/i/loader.svg" alt="">
      </div>
      <transition name="fade">
        <div class="cigarettes-pack-page__360" v-if="show360"></div>
      </transition>
    </div>
    <div
      id="fp"
      :style="{
        height: containerHeight + 'px',
      }"
    >
      <section
        class="fullpage"
        :class="{
          active: animateIndex === index,
          transition: slideTransitionRunning,
          leaving: animateLeaveIndex === index
        }"
        v-for="(item, key, index) in $slots"
        :key="index"
      >
        <div>
          <transition name="slide-left">
            <div
              v-show="animateIndex === index"
              class="animate-block"
              ref="anim"
            >
              <slot :name="key"></slot>
            </div>
          </transition>
          <!--
          <div v-if="nextButton.url && offsets.length == index + 1" class="_g-hidden-tablet">
            <div class="root-more _product">
              <div class="container">
                <transition name="slide-right">
                  <div v-show="animateIndex == index">
                    <router-link :to="{ path: nextButton.url }" class="button button__lg button__blue button__arrow" v-html="nextButton.text"></router-link>
                  </div>
                </transition>
              </div>
            </div>
          </div>
        -->
        </div>
      </section>
    </div>
  </div>
</template>
<script>

import { VctrApi } from "./../scripts-3d/vectaryToThreeJs";
import productMixin from "../mixins/productMixin";
import threeJsMixin from "../mixins/threeJsMixin";

export default {
  name: 'ProductPage',
  mixins: [productMixin, threeJsMixin],
  data() {
    const zoomModifier = .2;//1.7619;
    return {
      modelUrl: '/frontend/assets/3D/mevius-model-5/c4ae7000-1329-491d-9cdc-c4e830537aa0.gltf',
      states: [
        {
          "target": [0, 0.0054, 0],
          "position": [0.15677579898646565, 1.5699247457590104e-16, 0.2986991011086602],
          "zoom": 6.45 * zoomModifier,
          "cameraProximityRatio": .118
        }, {
          "target": [0.00185, 0.0069, 0],
          "position": [-0.21021101647638335, 0.350700000000000005, 0.31671991503665775],
          "zoom": 10.65 * zoomModifier,
          "cameraProximityRatio": .118
        }, {
          "target": [0.00134, 0.0059, 0],
          "position": [0.1763748760617525, -0.00514999999999998669, 0.3344285805410055],
          "zoom": 6.95 * zoomModifier,
          "cameraProximityRatio": .118
        }, {
          "target": [0.00134, 0.0059, 0],
          "position": [0, 0.0015, 0.33734226558641245],
          "zoom": 6.95 * zoomModifier,
          "cameraProximityRatio": .118
        }, {
          "target": [0, 0.0054, 0],
          "position": [0, 0, 0.33734226558641245],
          "zoom": 6.45 * zoomModifier,
          "cameraProximityRatio": .118
        }
      ],
      meshesToClone: [
        'тело_осн001'
      ],
      meshesToHide: [
        'SquarePlane',
        'SquarePlane_1',
      ],
      meshesCigarette: [
        'Cylinder_1',
        'Cylinder_1_2',
        'Cylinder_1_3',
        'Cylinder_2',
        'Cylinder_2_2',
        'Cylinder_2_3',
        'Cylinder_3',
        'Cylinder_3_2',
        'Cylinder_3_3',
        'Cylinder_4',
        'Cylinder_4_2',
        'Cylinder_5',
        'Cylinder_5_2',
        'Cylinder_5_3',
        'Cylinder_6',
        'Cylinder_6_2',
        'сигарета_аним'
      ],
      meshesShadow: [
        'Plane'
      ],
      innerTextureUrl: '/frontend/assets/3D/mevius-model-6/box-inside.png',
      planeData: {
        x: .002465,
        y: .00592,
        z: -.000054,
        width: .00297765,
        height: .0114,
        color: 0xffffff
      }
    }
  },
  created() {
    this.recalculateStatePositions();
  },
  mounted() {
    this.handleComponentMounted();
  },
  methods: {
    async animatePack() {
      let state = this.states[this.activeSection];

      // на 4 и 5 экранах открываем пачку, если она закрыта и вытаскиваем сигарету
      if (this.activeSection > 0 && this.activeSection < 4) {
        this.activateMobileRotate();
        this.animatePackPosition(state, 2000);
        if (!this.isUp) {
          this.isClosed = false;
          this.isUp = true;
          await this.switchPack(true);
          setTimeout(() => { this.moveCigarette(true)}, 2000);
        }
        return;
      }

      // анимация пачки
      if (!this.isClosed) {
        this.deactivateMobileRotate();
        this.isClosed = true;
        this.isUp = false;
        await this.moveCigarette(false);
        this.animatePackPosition(state);
        setTimeout(() => {
          this.switchPack(false)}, 700
        );
      } else {
        this.animatePackPosition(state, 1500);
      }
    },
    async moveCigarette(isOpen) {
      const cigaretteObjectName = 'сигарета_аним';
      const currentPosition = await this.vectaryApi.getPosition(cigaretteObjectName);
      const yPosition = isOpen ? 123.3020202690704 :  83.7540105655159;

      VctrApi.Utils.animate(
        'moveCigarette',
        500,
        "easeInOutQuad",
        async (timeFraction) => {
          if (!this.vectaryApi) return; // if user moved to another product page during animation
          const position = VctrApi.Utils.lerp(currentPosition, [currentPosition[0], yPosition, currentPosition[2]], timeFraction);
          await this.vectaryApi.setPositionAbsolute(cigaretteObjectName, position);
        },
        this.handleAnimationFinish
      );
    },
    async switchPack(isOpen) {
      const capObjectName = 'тело_внутр';
      const xPosition = isOpen ? 0.079807946005363988 : -0.009807946005363988;

      // анимация открытия крышки
      setTimeout(async () => {
        const currentPosition = await this.vectaryApi.getPosition(capObjectName);

        VctrApi.Utils.animate(
          'switchPack',
          700,
          "easeInOutQuad",
          async (timeFraction) => {
            if (!this.vectaryApi) return; // if user moved to another product page during animation
            const position = VctrApi.Utils.lerp(currentPosition, [xPosition, currentPosition[1], currentPosition[2]], timeFraction);

            await this.vectaryApi.setPositionAbsolute(capObjectName, position);
          },
          this.handleAnimationFinish
        );
      }, isOpen ? 0 : 400)
    },
  },
};
</script>

